import { FC, useCallback, useEffect, useState } from 'react';
import { SportNewDetailScreenProps } from './types';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import NewLayout from '../../WebLayout/NewLayout/NewLayout';
import { StyleSheet, Text, View } from 'react-native';
import { STYLE_VARS } from '../../constants/style-vars';
import { FONTS } from '../../constants';
import { INew } from '../../types';
import { NewApi } from '../../services/api';

const SportNewDetail: FC<SportNewDetailScreenProps> = ({
  navigation,
  route,
}) => {
  const id = route.params.id;
  const isDesktop = useIsDesktop();

  const [news, setNews] = useState<INew>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const newData = {
    title: 'KOWLOON CRICKET CLUB NEWS UPDATE',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_at: 'MAY 15, 2022',
    author: 'CRICKET CAPTAIN',
  };

  const getNews = useCallback(async (id: number) => {
    try {
      setIsLoading(true);
      const res = await NewApi.getNewsDetail(id);
      setNews(res.data);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getNews(id);
  }, [id, getNews]);

  if (isDesktop()) {
    return (
      <NewLayout
        title="Sports News"
        icon={require('../../assets/news.png')}
        haveGoBackButton={false}
        havePromotion={false}
        haveTitleBottomLine={false}
      >
        <Text style={[styles.titleText, { fontSize: 24, marginBottom: 16 }]}>
          {newData.title}
        </Text>
        <Text style={styles.dateText}>{newData.created_at}</Text>
        <Text style={[styles.contentText, { textAlign: 'justify' }]}>
          {newData.content}
        </Text>
        <View
          style={{
            flexDirection: 'row',
            alignContent: 'center',
            marginBottom: 20,
          }}
        >
          <Text style={styles.authorLabel}>AUTHOR:</Text>
          <Text style={styles.authorText}>{newData.author}</Text>
        </View>
      </NewLayout>
    );
  }

  return <></>;
};

export default SportNewDetail;

const styles = StyleSheet.create({
  titleText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    letterSpacing: 1,
    marginBottom: 10,
  },
  dateText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 14,
    color: STYLE_VARS.fccDarkerGrey,
    marginBottom: 25,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  contentText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 14,
    color: STYLE_VARS.fccDarkerGrey,
    marginBottom: 25,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  authorLabel: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    letterSpacing: 1,
    fontSize: 15,
    marginRight: 5,
  },
  authorText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 15,
    color: STYLE_VARS.fccDarkerGrey,
    marginBottom: 15,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
});
